import { render, staticRenderFns } from "./CustomersRegistryList.vue?vue&type=template&id=358e1820&scroll=false"
import script from "./CustomersRegistryList.vue?vue&type=script&lang=js"
export * from "./CustomersRegistryList.vue?vue&type=script&lang=js"
import style0 from "./CustomersRegistryList.vue?vue&type=style&index=0&id=358e1820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports